export const OldVyPalette = {
  text: {
    primary: '#0D1B27DE',
    secondary: '#1B3D5599',
    disabled: '#0D1B2761',
  },
  primary: {
    main: '#3A78F8',
    dark: '#1A5BC8',
    light: '#C3CAFA',
    contrastText: '#FFFFFF',
    hover: '#3A78F80A',
    selected: '#3A78F814',
    focus: '#3A78F81F',
    focusVisible: '#3A78F84D',
    outlinedBorder: '#3A78F880',
  },
  secondary: {
    main: '#C250FF',
    dark: '#9700DC',
    light: '#DF9FFB',
    contrastText: '#0D1B27DE',
    hover: '#C250FF0A',
    selected: '#C250FF14',
    focus: '#C250FF1F',
    focusVisible: '#C250FF4D',
    outlinedBorder: '#C250FF80',
  },
  tertiary: {
    main: '#00F2DE',
    dark: '#015F58',
    light: '#62FDE8',
    contrastText: '#0D1B27',
    hover: '#00F2DE0A',
    selected: '#00F2DE14',
    focus: '#00F2DE1F',
    focusVisible: '#00F2DE4D',
    outlinedBorder: '#00F2DE80',
  },
  error: {
    main: '#D32F2F',
    dark: '#C62828',
    light: '#EF5350',
    contrastText: '#FFFFFF',
    hover: '#D32F2F0A',
    selected: '#D32F2F14',
    focus: '#D32F2F1F',
    focusVisible: '#D32F2F4D',
    outlinedBorder: '#D32F2F80',
  },
  warning: {
    main: '#EF6C00',
    dark: '#E65101',
    light: '#FFB74D',
    contrastText: '#FFFFFF',
    hover: '#EF6C000A',
    selected: '#EF6C0014',
    focus: '#EF6C001F',
    focusVisible: '#EF6C004D',
    outlinedBorder: '#EF6C0080',
  },
  info: {
    main: '#0288D1',
    dark: '#01579B',
    light: '#03A9F4',
    contrastText: '#FFFFFF',
    hover: '#0288D10A',
    selected: '#0288D114',
    focus: '#0288D11F',
    focusVisible: '#0288D14D',
    outlinedBorder: '#0288D180',
  },
  success: {
    main: '#00E676',
    dark: '#01A452',
    light: '#8DFCAC',
    contrastText: '#0D1B27',
    hover: '#00E6760A',
    selected: '#00E67614',
    focus: '#00E6761F',
    focusVisible: '#00E6764D',
    outlinedBorder: '#00E67680',
  },
  background: {
    default: '#F5F5F5',
  },
  action: {
    active: '#0D1B278F',
    hover: '#0D1B270A',
    selected: '#0D1B2714',
    disabledBackground: '#0D1B270F',
    focus: '#0D1B271F',
    disabled: '#0D1B275C',
  },
  divider: '#0D1B271F',
  common: {
    white: '#FFFFFF',
    black: '#0D1B27',
  },
};
